import type { Site } from '@hotjar/site';
import { isAllowedWithoutGates } from '@hotjar/feature-flags';

export const UNIFIED_UPSELLING_FEATURE_KEY = 'bxp.unified_upselling';

export const isUnifiedUpsellingEnabled = (site: Site | undefined): boolean => {
  if (!site) {
    return false;
  }

  return isAllowedWithoutGates(UNIFIED_UPSELLING_FEATURE_KEY, site);
};
